export const categories = [
  {
    slug: 'video',
    name: '在线撸视频',
    icon: 'ri-video-line',
    description: '海量精彩短视频、直播内容，随时随地刷不停',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20mobile%20video%20streaming%20app%20interface%20with%20colorful%20thumbnails%2C%20modern%20flat%20design%2C%20warm%20lighting%2C%20creative%20content%20creation%20theme%2C%20soft%20gradient%20background%2C%20digital%20art%20style%2C%20clean%20composition&width=800&height=400&seq=cat-card-video&orientation=landscape',
  },
  {
    slug: 'cat',
    name: '在线撸猫',
    icon: 'ri-heart-line',
    description: '云吸猫天堂，萌宠日常、猫咪趣图一网打尽',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20fluffy%20orange%20tabby%20cat%20sitting%20on%20a%20soft%20blanket%20near%20a%20sunny%20window%2C%20warm%20cozy%20interior%2C%20soft%20natural%20lighting%2C%20minimalist%20Scandinavian%20style%20room%2C%20gentle%20pastel%20tones%2C%20clean%20composition%2C%20editorial%20pet%20photography&width=800&height=400&seq=cat-card-cat&orientation=landscape',
  },
  {
    slug: 'bbq',
    name: '在线撸串',
    icon: 'ri-fire-line',
    description: '美食烧烤文化聚集地，撸串攻略、探店分享',
    imageUrl: 'https://readdy.ai/api/search-image?query=Delicious%20grilled%20skewers%20on%20a%20charcoal%20grill%20with%20smoke%20rising%2C%20outdoor%20night%20market%20atmosphere%2C%20warm%20amber%20lighting%2C%20food%20photography%20style%2C%20simple%20dark%20background%2C%20appetizing%20textures%2C%20clean%20composition&width=800&height=400&seq=cat-card-bbq&orientation=landscape',
  },
  {
    slug: 'fitness',
    name: '在线撸铁',
    icon: 'ri-run-line',
    description: '健身打卡、运动教程、增肌减脂干货分享',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20gym%20interior%20with%20dumbbells%20and%20kettlebells%20on%20rack%2C%20clean%20minimalist%20fitness%20space%2C%20soft%20natural%20light%20from%20large%20windows%2C%20warm%20neutral%20tones%2C%20industrial%20concrete%20texture%2C%20professional%20fitness%20photography%2C%20clean%20composition&width=800&height=400&seq=cat-card-fitness&orientation=landscape',
  },
  {
    slug: 'code',
    name: '在线撸代码',
    icon: 'ri-code-line',
    description: '编程学习、技术分享、开源项目实战交流',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20coding%20workspace%20with%20laptop%20showing%20colorful%20code%20editor%2C%20minimalist%20desk%20setup%2C%20warm%20desk%20lamp%20lighting%2C%20dark%20mode%20IDE%20theme%2C%20developer%20aesthetic%2C%20soft%20ambient%20light%2C%20clean%20composition&width=800&height=400&seq=cat-card-code&orientation=landscape',
  },
  {
    slug: 'exam',
    name: '在线撸题',
    icon: 'ri-book-open-line',
    description: '刷题备考、知识问答、考试经验交流社区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20colorful%20highlighters%20and%20pens%20on%20wooden%20desk%2C%20study%20session%20aesthetic%2C%20warm%20natural%20lighting%2C%20minimalist%20stationery%20arrangement%2C%20soft%20cream%20background%2C%20academic%20vibe%2C%20clean%20composition&width=800&height=400&seq=cat-card-exam&orientation=landscape',
  },
];

export const featuredArticles = [
  {
    id: 1,
    categorySlug: 'video',
    categoryName: '在线撸视频',
    title: '2026年最值得关注的10个短视频创作趋势',
    excerpt: '短视频行业持续高速发展，AI辅助创作、互动直播、虚拟主播等新趋势正在重塑内容生态。本文为你盘点今年最值得关注的创作方向...',
    imageUrl: 'https://readdy.ai/api/search-image?query=Creative%20video%20editing%20timeline%20interface%20on%20large%20monitor%2C%20modern%20content%20creator%20studio%20setup%2C%20warm%20ambient%20lighting%2C%20professional%20video%20production%20aesthetic%2C%20soft%20color%20gradients%2C%20clean%20composition&width=800&height=400&seq=article-1&orientation=landscape',
    date: '2026-08-10',
    readTime: '8分钟',
  },
  {
    id: 2,
    categorySlug: 'cat',
    categoryName: '在线撸猫',
    title: '科学撸猫指南：猫咪最喜欢被摸的5个部位',
    excerpt: '不是所有猫咪都喜欢被摸肚子！本文从动物行为学角度出发，告诉你猫咪最享受被抚摸的部位，以及如何判断猫咪的心情状态...',
    imageUrl: 'https://readdy.ai/api/search-image?query=Happy%20cat%20being%20gently%20petted%20by%20human%20hand%2C%20closeup%20shot%2C%20warm%20cozy%20home%20setting%2C%20soft%20morning%20sunlight%2C%20gentle%20interaction%20moment%2C%20minimalist%20interior%2C%20clean%20composition&width=800&height=400&seq=article-2&orientation=landscape',
    date: '2026-08-09',
    readTime: '6分钟',
  },
  {
    id: 3,
    categorySlug: 'bbq',
    categoryName: '在线撸串',
    title: '全国烧烤地图：从东北到新疆，撸串江湖全攻略',
    excerpt: '中国烧烤文化博大精深，不同地区有着截然不同的烧烤风格和蘸料搭配。跟随我们的脚步，开启一场横跨全国的撸串之旅...',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20Chinese%20barbecue%20skewers%20on%20grill%20with%20vibrant%20spices%2C%20night%20market%20street%20food%20atmosphere%2C%20warm%20fire%20glow%2C%20steaming%20hot%20food%2C%20dark%20moody%20background%2C%20food%20photography%2C%20clean%20composition&width=800&height=400&seq=article-3&orientation=landscape',
    date: '2026-08-08',
    readTime: '10分钟',
  },
  {
    id: 4,
    categorySlug: 'fitness',
    categoryName: '在线撸铁',
    title: '新手撸铁入门：三个月从零基础到自律健身达人',
    excerpt: '健身不需要天赋，需要的是正确的方法和坚持。这份三个月的撸铁入门计划，包含了动作教学、饮食建议和进度追踪...',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20doing%20dumbbell%20curls%20in%20modern%20gym%2C%20focus%20on%20proper%20form%2C%20clean%20minimalist%20fitness%20space%2C%20soft%20natural%20light%2C%20motivational%20atmosphere%2C%20professional%20fitness%20photography%2C%20clean%20composition&width=800&height=400&seq=article-4&orientation=landscape',
    date: '2026-08-07',
    readTime: '12分钟',
  },
  {
    id: 5,
    categorySlug: 'code',
    categoryName: '在线撸代码',
    title: '零基础学编程：2026年最适合新手的编程语言推荐',
    excerpt: '编程不再是程序员的专利。无论你是学生、设计师还是创业者，掌握一门编程语言都能为你的职业发展带来新的可能...',
    imageUrl: 'https://readdy.ai/api/search-image?query=Laptop%20screen%20displaying%20clean%20modern%20code%20with%20syntax%20highlighting%2C%20minimalist%20desk%20setup%20with%20coffee%20cup%2C%20warm%20ambient%20lighting%2C%20developer%20workspace%20aesthetic%2C%20soft%20shadows%2C%20clean%20composition&width=800&height=400&seq=article-5&orientation=landscape',
    date: '2026-08-06',
    readTime: '7分钟',
  },
  {
    id: 6,
    categorySlug: 'exam',
    categoryName: '在线撸题',
    title: '高效刷题方法论：如何用最少的时间达到最好的备考效果',
    excerpt: '盲目刷题只会浪费时间。本文分享一套经过验证的高效刷题策略，帮助你建立知识体系，提高解题速度和准确率...',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20study%20desk%20with%20open%20textbooks%20and%20colorful%20sticky%20notes%2C%20warm%20desk%20lamp%20lighting%2C%20minimalist%20stationery%2C%20productive%20atmosphere%2C%20soft%20cream%20background%2C%20clean%20composition&width=800&height=400&seq=article-6&orientation=landscape',
    date: '2026-08-05',
    readTime: '9分钟',
  },
];

export const faqItems = [
  {
    question: '在线撸平台是什么？',
    answer: '在线撸是一个综合性的线上休闲互动内容平台，汇集了在线撸视频、在线撸猫、在线撸串、在线撸铁、在线撸代码、在线撸题等六大内容板块。用户无需下载任何应用，打开网页即可随时随地享受轻松有趣的内容阅读体验。',
  },
  {
    question: '在线撸平台需要注册吗？',
    answer: '目前在线撸平台完全免费开放，浏览所有内容无需注册登录。直接打开网站即可畅享全部内容。我们始终坚持即点即玩的理念，让用户零门槛体验在线撸的乐趣。',
  },
  {
    question: '在线撸平台的内容多久更新一次？',
    answer: '我们的编辑团队每日更新优质内容，确保用户每天都能看到新鲜有趣的文章和资讯。各分类板块保持高频更新节奏，让你每次访问都有新发现。',
  },
  {
    question: '如何找到我感兴趣的内容分类？',
    answer: '在首页即可看到六大分类入口，点击任一分类卡片即可进入对应的内容专区。每个分类页面都提供了丰富的文章列表，方便你快速浏览和筛选感兴趣的内容。',
  },
  {
    question: '在线撸平台有哪些特色功能？',
    answer: '平台提供分类浏览、精选推荐、全文搜索等核心功能。我们注重用户体验，操作界面简洁直观，加载速度快，并且支持面包屑导航和快捷回到顶部，让内容消费更加高效流畅。',
  },
  {
    question: '我可以投稿或分享内容到在线撸平台吗？',
    answer: '我们欢迎优质内容创作者加入！目前可以通过关于我们页面的联系方式提交合作意向，我们的内容团队会尽快与您取得联系，共同探讨内容合作的可能性。',
  },
];